import { call, cancelled } from 'redux-saga/effects';

import * as AppConstants from '../../../constants';
import { branch, cond, pipe } from '../../../sagas/Helpers';
import Logger from '../../../tools/Logger';

import * as InitiatePAHelpers from './helpers';

const log = Logger.child({
  component: 'mediator/useCases/initiatePremiumAccess/index',
});

export function* initiatePremiumAccess(action) {
  try {
    log.info('start initiatePremiumAccess');
    // eslint-disable-next-line require-atomic-updates
    action.data.target = yield call(InitiatePAHelpers.getCoachmarkDisplayPandoraType, action);

    yield call(
      pipe([
        InitiatePAHelpers.enforceLoggedInUser,
        branch(
          InitiatePAHelpers.isPAEligible,
          pipe([
            InitiatePAHelpers.openCoachmark,
            InitiatePAHelpers.waitForCoachmarkClose,
            InitiatePAHelpers.triggerReauth,
            InitiatePAHelpers.triggerWelcome,
          ]),
          cond([
            [
              () => action.data.context !== AppConstants.Ads.Rewards.ContextTypes.DEEP_LINK,
              InitiatePAHelpers.fallbackToUpsell,
            ],
          ]),
        ),
      ]),
      action,
    );
  } finally {
    if (yield cancelled()) {
      log.info('initiatePremiumAccess(): saga cancelled');
    }
  }
}
